/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import { State, Optional } from 'fierry/flux';

import Url from 'shared/client/url';


const SectorTransferState = new State([ Url ], { value: null, reverse: false });


export default new Optional([ Url ], SectorTransferState, (url) =>
{
  return url.getRoute().getValue() === '/sector.transfer.edit';
});
